import React from 'react';
import { Link } from 'react-router-dom';
const AppLink = ({ children, url, ...rest }) => {
  return (
    <Link to={url} {...rest}>
      {children}
    </Link>
  );
};

export default AppLink;
